(function () {
  function showBanner() {
    var el = document.getElementById('tt-consent-banner');
    if (el) el.hidden = false;
  }

  function hideBanner() {
    var el = document.getElementById('tt-consent-banner');
    if (el) el.hidden = true;
  }

  function isDecided(consent) {
    return (
      consent &&
      consent.marketing !== '' &&
      consent.analytics !== '' &&
      consent.preferences !== '' &&
      consent.sale_of_data !== ''
    );
  }

  function bindButtons() {
    var acceptBtn = document.getElementById('tt-consent-accept');
    var refuseBtn = document.getElementById('tt-consent-refuse');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: true, marketing: true, preferences: true, sale_of_data: true },
          hideBanner
        );
      });
    }

    if (refuseBtn) {
      refuseBtn.addEventListener('click', function () {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { analytics: false, marketing: false, preferences: false, sale_of_data: false },
          hideBanner
        );
      });
    }
  }

  function init() {
    var privacy = window.Shopify.customerPrivacy;
    bindButtons();

    var consent = privacy.currentVisitorConsent();
    if (!isDecided(consent) && privacy.shouldShowBanner()) {
      showBanner();
    }

    document.addEventListener('visitorConsentCollected', hideBanner);
  }

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) init();
      }
    );
  }
})();
